<template>
  <div class="column is-12 is-paddingless"
    v-if="tfsWithWarning.length">
    <qd-collapse :open="openDetail"
      class="message is-warning">
      <div
        slot="trigger"
        slot-scope="props"
        class="columns is-marginless pdv-0 is-vcentered
          is-justify-content-space-between message-header"
        role="button">
        <div class="column is-narrow pdl-0 columns is-marginless">
          <a>
            <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"/>
          </a>
        </div>
        <div class="column is-narrow pdl-0 columns is-marginless">
          <span v-if="tfsWithWarning.length > 1">
          {{$t('gestionAffectation.warningCard.titleWarningMulti',
            {nbreFaces: tfsWithWarning.length})}}
          </span>
          <span v-else>
            {{$t('gestionAffectation.warningCard.titleWarningSingle')}}
          </span>
        </div>
        <div class="column">
          <span class="is-block is-pulled-right">
            {{$t('gestionAffectation.warningCard.informationSelected',
            {nbFacesSelected: nbFacesSelected})}}
          </span>
        </div>
        <div class="column is-narrow">
          <a @click="$emit('close')">
            <b-icon icon="close-circle"/>
          </a>
        </div>
      </div>
      <div class="message-body border-none">
        <div class="content">
          <p class="has-text-centered has-text-weight-bold">
            {{ isAffectation ? $t('gestionAffectation.popUpActionAffecter.messageAction')
              : $t('gestionAffectation.popUpPreventionLaisserEnPlace.messageAction')}}
          </p>
          <b-table :data="tfsWithWarning" :bordered="true" :striped="true"
            class="max-height-30-vh overflow-y-auto">
            <b-table-column cell-class="vertical-alignment has-text-centered"
              header-class="has-text-default"
              field="selected"
              v-slot="props">
              <qd-switch v-model="props.row.selected"></qd-switch>
            </b-table-column>
            <b-table-column cell-class="vertical-alignment has-text-centered"
              header-class="has-text-default"
              field="codeFace"
              v-slot="props"
              :label="$t('gestionAffectation.warningCard.tab.codeFace')">
              {{ props.row.codeFace }}
            </b-table-column>
            <b-table-column
              header-class="has-text-default"
              field="motifs"
              v-slot="props"
              :label="$t('gestionAffectation.warningCard.tab.motif')">
              <span v-for="(motif, i) in props.row.motifs" :key="i">{{ motif }} <br/></span>
            </b-table-column>
            <b-table-column
              header-class="has-text-default"
              field="commandes"
              v-slot="props"
              :label="$t('gestionAffectation.warningCard.tab.commande')">
              <span v-for="(cmd, i) in props.row.commandes" :key="i">
                <router-link-blank
                  :to="{ name: 'c.bodac.commandes', params: { id: cmd.id } }"
                  :message="cmd.code + ' - ' + cmd.annonceurs">
                </router-link-blank>
              </span>
            </b-table-column>
          </b-table>
        </div>
      </div>
    </qd-collapse>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    tfsWithWarning: {
      type: Array,
      required: true,
    },
    isAffectation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    nbFacesSelected() {
      return this.tfsWithWarning.filter(f => !!f.selected).length;
    },
  },
  data() {
    return {
      openDetail: false,
    };
  },
};
</script>

<style>

</style>
